import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const accessToken = this.authService.getAccessToken();
    if (accessToken) {
      const authReq = this.buildAuthRequest(req);

      return next.handle(authReq).pipe(
        catchError((response: HttpErrorResponse) => {
          const shouldRefresh = this.shouldRefreshAccessToken(response);
          if (shouldRefresh) {
            return this.authService.refreshToken().pipe(
              catchError((err) => {
                this.authService.logout();
                return throwError(() => err);
              }),
              switchMap(() => {
                const reqWithRefreshedToken = this.buildAuthRequest(req);
                return next.handle(reqWithRefreshedToken);
              }),
            );
          }
          return throwError(() => response);
        }),
      );
    }
    return next.handle(req);
  }

  private buildAuthRequest(req: HttpRequest<any>): HttpRequest<any> {
    const accessToken = this.authService.getAccessToken();
    return req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + accessToken),
    });
  }

  private shouldRefreshAccessToken(response: HttpErrorResponse): boolean {
    return response.status === 401;
  }
}
